import { Injectable } from "@angular/core";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { Router } from "@angular/router";
import { ApiService } from "../../services/api/api.service";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { switchMap, tap, catchError } from "rxjs/operators";
import {
  FetchAuctionStatusesAttempt,
  FetchAuctionStatusesFailed,
  FetchAuctionStatusesSuccess,
  FetchRealEstateTypesAttempt,
  FetchRealEstateTypesFailed,
  FetchRealEstateTypesSuccess,
} from "../actions/shared.action";
import { ESharedActions } from "../actions/shared.action";
import { of } from "rxjs";
import { FetchAuctionAttempt } from "../actions/admin.action";

@Injectable()
export class SharedEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private apiService: ApiService,
    private http: HttpClient,
  ) {}

  @Effect()
  FetchRealEstateTypes$ = this.actions$.pipe(
    ofType<FetchRealEstateTypesAttempt>(
      ESharedActions.FetchRealEstateTypesAttempt,
    ),
    switchMap((action) =>
      this.apiService.get(`real-estate-types`).pipe(
        switchMap((response) =>
          of(new FetchRealEstateTypesSuccess(response.data)),
        ),
        catchError((response) => of(new FetchRealEstateTypesFailed())),
      ),
    ),
  );

  @Effect()
  FetchAuctionStatuses$ = this.actions$.pipe(
    ofType<FetchAuctionStatusesAttempt>(
      ESharedActions.FetchAuctionStatusesAttempt,
    ),
    switchMap((action) =>
      this.apiService.get(`auction-statuses?type=public`).pipe(
        switchMap((response) => {
          return of(new FetchAuctionStatusesSuccess(response.data));
        }),
        catchError((response) => of(new FetchAuctionStatusesFailed())),
      ),
    ),
  );
}
